import axios from "axios";

export default {
  getChats(context, keyword = "") {
    axios
      .get(`chats?keyword=${keyword}`)
      .then((res) =>
        context.commit(
          "setChats",
          res.data.data.map((el) => ({
            ago_time: el.last_message?.created_at || "",
            created_at: el.created_at,
            id: el.id,
            is_read: el.last_message?.is_read,
            last_message: el.last_message?.message || "",
            user: el.client,
            online: false,
            last_message_created_at: el.last_message?.time_ago ?? "",
            // last_message_created_at: el.last_message_created_at ?? "",
            last_message_created: new Date(el.last_message_created).getTime(),
            un_read_messages_count: el.un_read_messages_count,
          }))
        )
      )
      .catch((err) => console.log(err));
  },
};
